import React from 'react'

const LunchIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.08337 12.8334V7.49591C3.58754 7.3598 3.17192 7.08758 2.8365 6.67925C2.50108 6.27091 2.33337 5.79453 2.33337 5.25008V1.16675H3.50004V5.25008H4.08337V1.16675H5.25004V5.25008H5.83337V1.16675H7.00004V5.25008C7.00004 5.79453 6.83233 6.27091 6.49692 6.67925C6.1615 7.08758 5.74587 7.3598 5.25004 7.49591V12.8334H4.08337ZM9.91671 12.8334V8.16675H8.16671V4.08341C8.16671 3.27647 8.45108 2.58862 9.01983 2.01987C9.58858 1.45112 10.2764 1.16675 11.0834 1.16675V12.8334H9.91671Z'
      fill='currentColor'
    />
  </svg>
)

export default LunchIcon
